import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getProviderById,
  modifyProvider,
  modifyCustomField, //Groups
  addProvider,
  updateProvider,
} from 'providers/actions';

import { getEditing } from 'providers/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

import { valueFromEvent, createRoute } from 'lib/util';

class ProvidersFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { pid } = this.props.match.params;
    this.props.reset();
    pid && this.props.getById(pid, this.props.company.id, this.props.subcompany.id);
    //Groups
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'proveedores', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.provider.id
          ? this.props.update(
              this.props.provider.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.provider
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.provider);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'providers')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  handleValidation = (isValid) => this.setState({ isValid });

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
    });
}

const mapStateToProps = (state) => ({
  provider: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addProvider,
  error: addGrowlError,
  getById: getProviderById,
  modify: modifyProvider,
  reset: resetForm,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  success: addGrowlSuccess,
  update: updateProvider,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProvidersFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/containers/ProviderFormHandlers.js